<template>
  <Modal
    ref="viewerModal"
    :values="{ id: 'viewer_modal', size: 'lg' }"
    :noCloseOnBackdrop="false"
    :onClose="{}"
    @onShown="whenModalVisible"
    :hideFooter="true"
  >
    <template slot="body">
      <ImageViewer ref="viewer" :images="images" :fileIndex="index" :thumbs="thumbs"/>
    </template>
  </Modal>
</template>

<script>
import { mapGetters } from 'vuex';
import ImageViewer from '@/views/Shared/ImageViewer.vue';
import Modal from '@/views/Shared/Modal';

export default {
  name: 'ImageViewerModal',
  components: {
    ImageViewer,
    Modal,
  },
  data() {
    return {
      files: [],
      fileIndex: 0,
      setId: null,
      type: 'detection',
    };
  },
  computed: {
    ...mapGetters('Auth', ['fileUrl']),
    images() {
      return this.files.map((file) => ({
        name: file.name,
        mime: file.mime,
        url: this.fileUrl(file.id, this.setId, this.type),
      }));
    },
    thumbs() {
      return this.files.map((file) => ({
        name: file.name,
        url: `${this.fileUrl(file.id, this.setId, this.type)}&cvt=thumb_large`,
      }));
    },
    index() {
      return this.fileIndex;
    }

  },
  mounted() {

  },
  beforeDestroy() {

  },
  methods: {
    openModal(files, fileIndex, setId, type) {
      this.fileIndex = fileIndex;
      this.files = files;
      this.setId = setId;
      this.type = type;
      this.$refs.viewerModal.show();
    },
    whenModalVisible() {
      this.$nextTick(() => {
        this.$refs.viewer.load();
      });
    },
  }
};
</script>
<style lang=scss></style>
